import type { LoginResultWithEmail } from './types';

export const LOGIN_RESULT_DEFAULT_VALUE: LoginResultWithEmail = {
  success: true,
};
